import "./styles/index.css";
import "./styles/profile.css";

import { Divider, Spin, Tabs, Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

// components
import AllAppRoutes from "../../common/routes";
import FooterDisplay from "../../components/Restaurant/Footer";
import RestaurantBusiness from "./RestaurantBusiness";
import RawFoodBusiness from "./RawFoodBusiness";
import StoreBusiness from "./StoreBusiness";
import useUserProfile from "../../hooks/useUserProfile";

const BusinessProfile = () => {
  const { TabPane } = Tabs;
  const { userProfile: user } = useUserProfile();
  const navigate = useNavigate();
  const newAntIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "#008060" }} spin />
  );

  return (
    <div className="userprofile">
      <Spin spinning={false} indicator={newAntIcon}>
        <div className="profile-content pb-40">
          {/* <Navbar /> */}
          <div className="gray_bg_profile">
            <div className="profile_to_left">
              <div className="">
                <div className="profile_nav">{/* <RestaurantSideNav /> */}</div>
              </div>
            </div>
            <div className="profile_to_right">
              <div className="contain">
                <div className="main_container">
                  {/* <MobileDashTabs /> */}
                  <div className="main_container_title_div mb-5 mt-10 flex items-center justify-between">
                    <h5 className="!mt-0">My Business Profiles</h5>
                    <Button
                      type="primary"
                      onClick={() => navigate(AllAppRoutes.become_business)}
                      className="bg-gray-900"
                    >
                      Edit My Business
                    </Button>
                  </div>
                  <Divider style={{ margin: "0px 0 5px" }} />
                  <Tabs defaultActiveKey="restaurant" type="card">
                    {user?.isRestaurantOwner && (
                      <TabPane tab="Restaurant" key="restaurant">
                        <RestaurantBusiness user={user} />
                      </TabPane>
                    )}

                    {user?.isRawFoodOwner && (
                      <TabPane tab="Wholesale" key="raw_food">
                        <RawFoodBusiness user={user} />
                      </TabPane>
                    )}

                    {user?.isStoreOwner && (
                      <TabPane tab="Retail" key="stores">
                        <StoreBusiness user={user} />
                      </TabPane>
                    )}
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Spin>
      <FooterDisplay />
    </div>
  );
};
export default BusinessProfile;
